import React from "react";
import { Link } from "react-router-dom";

const CTASection = ({
  heading,
  subheading,
  description,
  imageSrc,
  imageAlt = "CTA Image",
  buttonText = "Book a Demo",
  buttonLink = "/get-in-touch",
  reverse = false,
  bgColor = "bg-[#fff]",
  cardbgColor,
}) => {
  return (
    <section className={`py-8 md:py-12 lg:py-16 ${bgColor} mb-10 lg:mb-10`}>
      <div className="ml-0 lg:ml-16 xl:ml-24">
        <div className="p-0 md:p-8 lg:p-10 rounded-l-lg md:rounded-l-xl rounded-r-none">
          <div
            className={`grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10 items-center p-4 md:p-6 lg:p-0 ${cardbgColor}`}
          >
            {/* Image Side - Order-last logic handles the reverse on desktop */}
            <div
              className={`relative h-64 md:h-80 rounded-lg overflow-hidden ${reverse ? "lg:order-2" : "lg:order-1"}`}
            >
              <img
                src={imageSrc}
                alt={imageAlt}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content Side */}
            <div
              className={`flex flex-col justify-center text-center lg:text-left items-center lg:items-start ${reverse ? "lg:order-1" : "lg:order-2"}`}
            >
              <h2 className="font-bold  mb-4 md:mb-5">
                {heading}
                {subheading && (
                  <span className="block  mt-2 md:mt-3">{subheading}</span>
                )}
              </h2>

              <p className="    opacity-90 mb-6 md:mb-8 leading-relaxed max-w-xl">
                {description}
              </p>

              <div>
                <Link
                  to={buttonLink}
                  className="btn-primary btn font-medium px-6 md:px-8 py-3 md:py-3.5 inline-block"
                >
                  {buttonText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
